import React from "react";
import Image from "react-bootstrap/Image";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";

export const MainSubscriptionHome = ({ onClick, backButton }) => {
  return (
    <React.Fragment>
      <div className="bank_and_other_details_onboarding_main">
        <div
          id="onboarding-scrollbar"
          className="bank_and_other_details_onboarding_homescreen"
        >
          <div className="display-toggle-stepup-button">
            <RightSidePannel selectedTab={4} />
          </div>
          <h3 className="bank_and_other_details_onboarding-heading-text-big">
            Subscription and Other Settings
          </h3>
          <hr />
          <h4 className="heading-text-bank-home">Subscription</h4>
          <Image
            className="image-subscriptions-home"
            src={require("../../../../../assets/images/onboarding/storeSetup6.png")}
            alt="bank"
            title="bank"
            fluid
          />
          <div className="col-12 d-flex justify-content-center">
            <p className="paragraph-text-bank-home">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
              convallis tellus id malesuada faucibus. Donec dolor mauris.
            </p>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button mt-5">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              onClick={backButton}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              buttonText="Next"
              onClick={onClick}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
//update 16-06-20
